/* ============
 * Mutations for the reminder module
 * ============
 *
 * The mutations that are available on the
 * reminder module.
 */

import types from './mutation-types';
// import initialState from './state';

export default {
  [types.FETCH_REMINDER_LIST](state) {
    state.isReminderListLoading = true;
  },
  [types.FETCH_REMINDER_LIST_SUCCESS](state, response) {
    state.isReminderListLoading = false;
    state.totalCount = response.totalCount;
    state.assessmentReminders = response.assessmentReminders;
  },
  [types.FETCH_REMINDER_LIST_FAIL](state, error) {
    state.isReminderListLoading = false;
    state.error = error;
  },
  [types.CREATE_REMINDER](state) {
    state.isReminderListLoading = true;
  },
  [types.CREATE_REMINDER_SUCCESS](state) {
    // , record) {
    // state.assessmentReminders = [...state.assessmentReminders, record];
    state.isReminderListLoading = false;
  },
  [types.CREATE_REMINDER_FAIL](state, error) {
    state.isReminderListLoading = false;
    state.error = error;
  },

  [types.UPDATE_REMINDER](state) {
    state.loading = true;
  },
  [types.UPDATE_REMINDER_SUCCESS](state, response) {
    state.loading = false;
    state.assessmentReminders = response;
  },
  [types.UPDATE_REMINDER_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  }
};
